/// <reference path="../../_ext/Editors/EditorDialogBase.ts" />
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkReturnItemsDialog extends _Ext.ItemEditorDialog<JobWorkReturnItemsRow> {
        protected getFormKey() { return JobWorkReturnItemsForm.formKey; }
        protected getLocalTextPrefix() { return JobWorkReturnItemsRow.localTextPrefix; }
        protected getDeletePermission() { return JobWorkReturnItemsRow.deletePermission; }
        protected getInsertPermission() { return JobWorkReturnItemsRow.insertPermission; }
        protected getUpdatePermission() { return JobWorkReturnItemsRow.updatePermission; }
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        public form = new JobWorkReturnItemsForm(this.idPrefix);

        // #region Public Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public newLineNo: number;
        public Totals: number;
        public HasBom: boolean = true;
        public Closing: boolean;
        public ItemMaster: any;
        // #endregion 

        constructor() {
            super();

            //Make grid full width
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.LaborDetails);

            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.UnitRate);
            //q.setTextRightAlign(this.form.StdPurity);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.WstPer);
            q.setTextRightAlign(this.form.WstWt);
            q.setTextRightAlign(this.form.UnitLabour);

            // **** Assign Values to BOM and Labor Editor ****
            // this will be used to calculate Rate for RM and Labor while adding new item.
            this.form.BOMDetails.RateListId = this.RateListId;
            this.form.LaborDetails.LaborListId = this.LaborListId;
            this.form.LaborDetails.LaborMarkup = this.LaborMarkup;


            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

          
            // **** Set Stone Type in SubType ****
            this.form.ProductTypeId.changeSelect2(e => {

                this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                this.entity.ItemTypeId = this.form.ItemTypeId.value;
                this.form.CategoryId.ItemTypeId = this.form.ItemTypeId.value;
                this.form.CategoryId.updateItems();
                this.form.SubCategoryId.value = "";
                this.Setfields();

            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.CategoryId = parseInt(this.form.CategoryId.value);
                this.form.SubCategoryId.updateItems();
            })
            // **** On Wastage % Change Event **** 
            this.form.WstPer.changeSelect2(e => {
                this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            });


            //*** BOM row add Edit Delete Event ****
            //Used to Update Amount weight and pieces from BOM to item
            if (!closed) {
                this.form.BOMDetails.element.on('DOMNodeInserted DOMNodeRemoved', () => {
                    var Pcs = 0, Wt = 0, othrpcs = 0, othrwt = 0, clrpcs = 0, clrwt = 0, diapcs = 0, diawt = 0, grswt = 0, cts = 0, gms = 0, rate = 0;
                    for (var k of this.form.BOMDetails.getItems()) {

                        if (k.ItemTypeId == 104) {
                            Wt += k.Weight;
                        }
                        if (k.ItemTypeId == 105 && k.CalcOnId == 5) {
                            cts += k.Weight;
                            diapcs += k.Pieces
                        }
                        if (k.ItemTypeId == 105 && k.CalcOnId == 4) {
                            gms += k.Weight;
                            clrpcs += k.Pieces;
                        }

                        rate += k.BomAmount;

                    }
                    var self = this;
                    var labour = this.form.LaborDetails.getItems();
                    
                    this.form.NetWeight.value = Wt;
                    this.form.OtherPieces.value = othrpcs;
                    this.form.StonePieces.value = clrpcs;
                    this.form.StoneWeight.value = gms;
                    this.form.DiamondPieces.value = diapcs;
                    this.form.DiamondWeight.value = cts;
                    this.form.Weight.value = Wt + gms + (cts / 5);
                    this.form.UnitRate.value = rate;
                    labour.forEach(function (lvalue) {
                        lvalue.Pieces = self.form.Pieces.value;
                        lvalue.Weight = self.form.Weight.value;
                        if (lvalue.CalcOnId != 3)
                            lvalue.LabourAmount = lvalue.Weight * lvalue.LabourRate;
                        else
                            lvalue.LabourAmount = lvalue.Pieces * lvalue.LabourRate;
                    });

                   

                    this.form.NetAmount.value = this.form.UnitRate.value + this.form.UnitLabour.value;

                    if (this.form.Pieces.value != null) {
                        var pieces = parseInt(this.form.Pieces.value.toString());
                        var netamount = parseFloat(this.form.NetAmount.value.toString());
                        this.form.GrossAmount.value = (pieces * netamount);
                    }

                    this.form.LaborDetails.setItems(labour);
                });


                this.form.LaborDetails.element.on('DOMNodeInserted DOMNodeRemoved', () => {
                    var LAmount= 0;
                    for (var k of this.form.LaborDetails.getItems()) {

                        LAmount += k.LabourAmount;
                    }
                    this.form.UnitLabour.value = LAmount;

                });
            }


            // **** On Labor Rate Change Event **** 
            this.form.UnitLabour.changeSelect2(e => {
                this.form.NetAmount.value = parseFloat(this.form.UnitRate.value.toString()) + parseFloat(this.form.UnitLabour.value.toString());
                if (this.form.Pieces.value != null) {
                    var pieces = parseInt(this.form.Pieces.value.toString());
                    var netamount = parseFloat(this.form.NetAmount.value.toString());
                    this.form.GrossAmount.value = (pieces * netamount);
                }
            });

            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 
            this.form.ProductCode.changeSelect2(e => {
                try {
                    let id;
                    OMS.ProductMasterService.CustomList({ ProductCode: this.form.ProductCode.value.toUpperCase() },
                        response => {
                            id = response.Entities[0];
                        }, { async: false });
                    if (id.ProductId != null || id.ProductId > 0) {
                        Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                        this.form.ProductCode.value = "";
                        this.form.ProductCode.element.focus();
                        return;

                    }
                }
                catch (undefined) {

                }
            });

        }

        getItem() {
            return this.getSaveEntity()
        }
        // **** Method to set fields as per Item Type Called from various Events ****
        private Setfields() {
            if (this.entity.ItemTypeId != 101) {
                Serenity.EditorUtils.setReadonly(this.form.UnitRate.element, false);
                q.hideField(this.form.BOMDetails);
                q.hideField(this.form.BrandId);
                q.hideField(this.form.CollectionId);
                q.hideField(this.form.SuperTypeId);
                q.hideField(this.form.ProductSizeId);
                q.hideField(this.form.UnitLabour);
                q.hideField(this.form.NetWeight);
                q.hideField(this.form.DiamondPieces);
                q.hideField(this.form.DiamondWeight);
                q.hideField(this.form.StonePieces);
                q.hideField(this.form.StoneWeight);
                q.hideField(this.form.OtherWeight);
                q.hideField(this.form.OtherPieces);
                q.hideField(this.form.WstPer);
                q.hideField(this.form.WstWt);
                q.hideField(this.form.Line_No);
                q.hideField(this.form.SKU);
                q.hideField(this.form.CategoryId);
                q.hideField(this.form.HasBom);
                q.hideEditorTab(this.form.BOMDetails);
                q.hideEditorTab(this.form.ImageName);
                this.form.HasBom.value == false;

                // **** Metal Fields **** //
                if (this.form.ProductTypeId.value == "5" || this.form.ProductTypeId.value == "6" || this.form.ProductTypeId.value == "7") {
                    q.showAndDisableField(this.form.KaratId);
                    q.showAndDisableField(this.form.MetalColorId);
                    q.showAndDisableField(this.form.Purity);
                    q.showAndDisableField(this.form.PureWeight);
                    //q.showAndDisableField(this.form);
                    q.showAndDisableField(this.form.HSN);
                    q.showAndDisableField(this.form.UnitRate);
                    q.hideField(this.form.CalcOnId);
                    q.hideField(this.form.CalcUnitId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.ShapeId);
                    q.hideField(this.form.QualityId);
                    q.hideField(this.form.StoneColorId);
                    q.hideField(this.form.StoneSizeId);
                    q.hideField(this.form.SieveId);
                    q.hideField(this.form.Pieces);
                    q.hideField(this.form.SubCategoryId);
                    q.hideField(this.form.StoneCutId);
                    q.hideField(this.form.StonePolishId);
                    q.hideField(this.form.StoneSymmetryId);
                    q.hideField(this.form.StoneFluorescenceId);
                    q.hideField(this.form.StoneCuletId);
                    q.hideField(this.form.StoneGirdleId);
                    q.hideField(this.form.StoneTable);
                    q.hideField(this.form.StoneDepth);
                    q.hideField(this.form.Pieces);


                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 104;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "123";

                    switch (this.form.ProductTypeId.value) {
                        case "5":
                            this.form.SubCategoryId.value = "301";
                            break;
                        case "6":
                            this.form.SubCategoryId.value = "302";
                            break;
                        case "7":
                            this.form.SubCategoryId.value = "303";
                            break;
                    }
                }

                // **** Stone Fields **** //
                if (this.form.ProductTypeId.value == "11" || this.form.ProductTypeId.value == "12" || this.form.ProductTypeId.value == "13") {
                    q.showAndDisableField(this.form.SubCategoryId);
                    q.showAndDisableField(this.form.ShapeId);
                    q.showAndDisableField(this.form.QualityId);
                    q.showAndDisableField(this.form.SieveId);
                    q.showAndDisableField(this.form.StoneColorId);
                    q.showAndDisableField(this.form.StoneSizeId);
                    q.showAndDisableField(this.form.CalcOnId);
                    q.showAndDisableField(this.form.UnitRate);
                    q.hideField(this.form.KaratId);
                    q.hideField(this.form.MetalColorId);
                    q.hideField(this.form.MetalId);
                    q.hideField(this.form.Purity);
                    q.hideField(this.form.PureWeight)
                    q.hideField(this.form.Purity);
                    q.showAndDisableField(this.form.CalcUnitId);

                    if (this.form.ItemTypeId.value == 0)
                        this.form.ItemTypeId.value = 105;

                    if (this.form.CategoryId.value.length == 0)
                        this.form.CategoryId.value = "124";

                    if (this.form.SubCategoryId.value == "348") {
                        q.hideField(this.form.StoneCutId);
                        q.hideField(this.form.StonePolishId);
                        q.hideField(this.form.StoneSymmetryId);
                        q.hideField(this.form.StoneFluorescenceId);
                        q.hideField(this.form.StoneCuletId);
                        q.hideField(this.form.StoneGirdleId);
                        q.hideField(this.form.StoneTable);
                        q.hideField(this.form.StoneDepth);
                        q.hideField(this.form.CertificateNo);
                    }
                    // **** Solitaire **** //
                    if (this.form.SubCategoryId.value == "349") {
                        q.showAndDisableField(this.form.StoneCutId);
                        q.showAndDisableField(this.form.StonePolishId);
                        q.showAndDisableField(this.form.StoneSymmetryId);
                        q.showAndDisableField(this.form.StoneFluorescenceId);
                        q.showAndDisableField(this.form.StoneCuletId);
                        q.showAndDisableField(this.form.StoneGirdleId);
                        q.showAndDisableField(this.form.StoneTable);
                        q.showAndDisableField(this.form.StoneDepth);
                        q.showAndDisableField(this.form.CertificateNo);
                        q.showAndDisableField(this.form.Pieces);
                        q.showAndDisableField(this.form.Weight);
                        q.showAndDisableField(this.form.Lab);
                    }
                    this.entity.ProductId > 0 ? q.showAndDisableField(this.form.SubCategoryId) : q.showAndSetRequiredField(this.form.SubCategoryId);
                }
            }
            else {
                q.showAndDisableField(this.form.CategoryId);
                q.showAndDisableField(this.form.SubCategoryId);
                q.showAndDisableField(this.form.BrandId);
                q.showAndDisableField(this.form.CollectionId);
                q.showAndDisableField(this.form.SuperTypeId);
                q.showAndDisableField(this.form.ProductSizeId);
                //this.entity.ProductId > 0 ? this.form.HasBom.value == true ? q.showAndDisableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom) : q.showAndEnableField(this.form.HasBom);
                q.showAndDisableField(this.form.HasBom);

                this.form.HasBom.value == true ? q.showFieldAndCategory(this.form.BOMDetails) : q.showFieldAndCategory(this.form.BOMDetails, false);
                this.form.HasBom.value == true ? q.hideField(this.form.Purity) : q.showAndDisableField(this.form.Purity);
                this.form.HasBom.value == true ? q.hideField(this.form.PureWeight) : q.showAndDisableField(this.form.PureWeight);
                q.showAndDisableField(this.form.Weight);
                //this.form.HasBom.value == true ? q.hideEditorTab(this.form.BOMDetails, false) : q.hideEditorTab(this.form.BOMDetails);
                q.showAndDisableField(this.form.CalcUnitId);
                q.showAndDisableField(this.form.MetalId);
                this.form.HasBom.value == true ? q.hideField(this.form.KaratId) : q.showAndDisableField(this.form.KaratId);
                this.form.HasBom.value == false ? parseInt(this.form.KaratId.value) > 0 ? q.showAndSetRequiredField(this.form.UnitRate) : q.showAndDisableField(this.form.UnitRate) : q.showAndDisableField(this.form.UnitRate);


                if (!this.form.HasBom.value) {
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                    q.HideCategoryLable(this.element)
                }
                q.showAndDisableField(this.form.Line_No);
                q.hideEditorTab(this.form.BOMDetails, false);
                q.hideEditorTab(this.form.ImageName, false);
                q.showAndDisableField(this.form.UnitLabour);
                q.showAndDisableField(this.form.NetWeight);
                q.showAndDisableField(this.form.DiamondPieces);
                q.showAndDisableField(this.form.DiamondWeight);
                q.showAndDisableField(this.form.StonePieces);
                q.showAndDisableField(this.form.StoneWeight);
                q.showAndDisableField(this.form.OtherWeight);
                q.showAndDisableField(this.form.OtherPieces);
                q.showAndDisableField(this.form.WstPer);
                q.showAndDisableField(this.form.WstWt);
                q.hideField(this.form.MetalColorId);
                q.hideField(this.form.ShapeId);
                q.hideField(this.form.QualityId);
                q.hideField(this.form.StoneColorId);
                q.hideField(this.form.StoneSizeId);
                q.hideField(this.form.SieveId);
                q.hideField(this.form.StoneCutId);
                q.hideField(this.form.StonePolishId);
                q.hideField(this.form.StoneSymmetryId);
                q.hideField(this.form.StoneFluorescenceId);
                q.hideField(this.form.StoneCuletId);
                q.hideField(this.form.StoneGirdleId);
                q.hideField(this.form.StoneTable);
                q.hideField(this.form.StoneDepth);
                q.showAndDisableField(this.form.CertificateNo);
                q.showAndDisableField(this.form.Lab);
            }

            q.showAndDisableField(this.form.ProductCode);
            q.showAndDisableField(this.form.ProductName);
            q.showAndDisableField(this.form.ProductTypeId);
            q.showAndDisableField(this.form.CalcOnId);
            q.showAndDisableField(this.form.CalcUnitId);
            q.showAndDisableField(this.form.TaxCode);
            q.showAndDisableField(this.form.HSN);

        }

        protected onDialogOpen() {
            super.onDialogOpen();
            //if (this.form.Line_No.value === "") {
            //    Purchase.PurchaseMasterService.GetLineNo({}, response => this.newLineNo = response.LineNo, {
            //        async: false
            //    });   
            //    this.form.Line_No.value = this.newLineNo.toString();
            //}
            if (this.form.Line_No.value != "") { 

                //to set pieces and weight values for bom
                var boms = [];
                var BOMItems = this.form.BOMDetails.getItems();
                var oldweights= [];
                var oldpieces= [];
                var BOMProductId= [];
                for (var i = 0; i < BOMItems.length; i++) {
                    var item = BOMItems[i];

                    oldweights.push(item.Weight);
                    oldpieces.push(item.Pieces);
                    BOMProductId.push(item.BOMProductId);
                }
                this.form.BOMDetails.PartyId = this.form.PartyId.value;
                this.form.BOMDetails.TransID = this.entity.TransId;
                this.form.BOMDetails.VoucherTypeId = this.entity.VoucherTypeId;
            }
            //if (parseInt(this.form.TransId.value) > 0) {
            //    Serenity.EditorUtils.setReadOnly(this.form.ProductCode, true);
            //    // Change TransID to RefTransID
            //    var refid = Stock.StockItemRow.getLookup().items.filter(x => x.TransId == parseInt(this.form.TransId.value)
            //        && x.LineNo == parseInt(this.form.Line_No.value)
            //        && x.PrdId == parseInt(this.form.ProductId.value))[0].StockId
            //    if (refid > 0) {

            //        Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
            //    }
            //}
        } 
    }
}